import { render, staticRenderFns } from "./ProjectsListSearchbar.vue?vue&type=template&id=4894fec1"
import script from "./ProjectsListSearchbar.vue?vue&type=script&lang=js"
export * from "./ProjectsListSearchbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports